module.exports = "/fonts/vendor/@fontsource/inter/files/inter-all-900-normal.woff?2aa28baf54084e22061b662b5b90e912";